/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";

import { temp as tempActions, data as dataActions } from "actions";
import { statuses } from "api";

let initTimeout: any;
let tempLock: boolean = false;

export default function Init() {
   const dispatch = useDispatch();
   const data = useSelector((state: any) => state.data);
   const tempSet = useSelector((state: any) => state.temp.set);
   const tempGet = useSelector((state: any) => state.temp.get);

   const [getParameters] = useSearchParams();

   function autoBackup() {
      if (data.email && data.v_name && data.temp_autoBackup) {
         console.log("backup!!", data);
         dispatch({
            type: tempActions.set.call,
            payload: {
               ...data,
            },
         });
      }
   }

   if (tempSet.status === statuses.resolved && data.temp_autoBackup) {
      if (tempSet.data) {
         tempLock = true;
         dispatch({
            type: dataActions.set,
            payload: {
               ...data,
               temp_exhibition_idx: parseInt(tempSet.data),
            },
         });
      }
      dispatch({
         type: tempActions.set.reset,
      });
   } else if (tempSet.status === statuses.rejected) {
      dispatch({
         type: tempActions.set.reset,
      });
   }

   useEffect(function () {
      if (getParameters.get("idx")) {
         dispatch({
            type: tempActions.get.call,
            payload: {
               temp_exhibition_idx: getParameters.get("idx"),
            },
         });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   useEffect(
      function () {
         if (data.email && data.v_name && tempSet.status === statuses.idle && data.temp_autoBackup) {
            if (tempLock) {
               tempLock = false;
               return;
            }
            console.log("tempSet.status", tempSet.status);
            clearTimeout(initTimeout);
            console.log("clear", initTimeout);
            initTimeout = setTimeout(autoBackup, 1000 * 5);
            console.log("set", initTimeout);
         }
      },
      [{ ...data, temp_exhibition_idx: 0 }]
   );

   if (tempGet.status === statuses.resolved) {
      dispatch({
         type: tempActions.get.reset,
      });
      dispatch({
         type: dataActions.set,
         payload: {
            ...data,
            ...tempGet.data,
            temp_files: tempGet.data.files ? tempGet.data.files.split(",") : [],
            startdate: dayjs(tempGet.data.startdate).format("YYYY-MM-DD"),
            enddate: dayjs(tempGet.data.enddate).format("YYYY-MM-DD"),
         },
      });
   }
   console.log("data", data);

   return <></>;
}
